import * as classnames from 'classnames/bind'
import * as React from 'react'

import { ContentState, convertToRaw, EditorState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { Editor } from 'react-draft-wysiwyg'
import { dispatch } from '../../store'
import styles from './lecture-brief-editor.scss'
import itemStyles from './lecture-item.scss'


const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean,
  content: string,
  lectureId: string
}

interface IState {
  isLoadInLectureDescpt: boolean,
  editorState: EditorState
}

class LectureBriefEditor extends React.Component<IProps, IState> {
  public state: IState = {
    isLoadInLectureDescpt: false,
    editorState: EditorState.createEmpty()
  }

  public onEditorStateChange = (editorState: EditorState) => {
    const { lectureId } = this.props
    this.setState({ editorState })
    dispatch.lectures.updateLecture({
      lectureId, updated: { description: draftToHtml(convertToRaw(editorState.getCurrentContent())) }
    })
  }

  public render() {
    // render HTML by WYSIWYG HTML Editor: https://www.froala.com/wysiwyg-editor
    const { isEdit, content } = this.props
    const { editorState, isLoadInLectureDescpt } = this.state

    if (!isLoadInLectureDescpt) {
      const contentBlock = htmlToDraft(content)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        const setEditorState = EditorState.createWithContent(contentState)
        this.setState({
          editorState: setEditorState,
          isLoadInLectureDescpt: true
        })
      }
    }
    return (
      <div className={cx('section')}>
        <div className={cx('section_header')}>講座簡介</div>
        <div className={cx('section_content')}>
          {
            isEdit ? (
              <Editor
                editorState={editorState}
                wrapperClassName="lecture-editor-wrapper"
                editorClassName="lecture-editor"
                onEditorStateChange={this.onEditorStateChange}
              />
            ) : <div dangerouslySetInnerHTML={{ __html: content }} />
          }
        </div>
      </div>
    )
  }
}

export default LectureBriefEditor


// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-brief-editor.tsx